import React, {Component} from 'react';
import ReactSVG from 'react-svg';
import { FormattedMessage } from 'react-intl';

import ExploreIcon from './../../assets/img/compass.svg';
import EventsIcon from './../../assets/img/calendar.svg';
import ARIcon from './../../assets/img/3d.svg';
import PostcardIcon from './../../assets/img/postcard.svg';

import styles from './NavigationBar.module.css';

class NavigationBar extends Component {

    constructor(props){
        super(props);
        this.lastPageYOffset = 0;
        this.state = {
            navBar: this.props.fixed ? "idle" : "hidden",
        }

        this.hide = this.hide.bind(this);
        this.goToHome = this.goToHome.bind(this);
        this.goToEvents = this.goToEvents.bind(this);
        this.goToMap = this.goToMap.bind(this);
        this.goToPostcard = this.goToPostcard.bind(this);
    }

    showHide(pageYOffset){
        let height = Math.max( document.body.scrollHeight, document.body.offsetHeight );

        if ((navigator.platform.indexOf("iPhone") != -1) ||
            (navigator.platform.indexOf("iPad") != -1) ||
            (navigator.platform.indexOf("iPod") != -1)){
            if(pageYOffset >= this.lastPageYOffset && pageYOffset > 0 && (this.state.navBar === "show" || this.state.navBar === "idle")){
                this.setState({
                    navBar: "hide"
                });
            }
            if(pageYOffset < this.lastPageYOffset && pageYOffset < height-900 && this.state.navBar !== "show"){
                this.setState({
                    navBar: "show"
                });
            }
        }else{
            if(pageYOffset >= this.lastPageYOffset && (this.state.navBar === "show" || this.state.navBar === "idle")){
                this.setState({
                    navBar: "hide"
                });
            }
            if(pageYOffset < this.lastPageYOffset && this.state.navBar !== "show"){
                this.setState({
                    navBar: "show"
                });
            }
        }
        this.lastPageYOffset = pageYOffset;
    }

    show(){
        this.setState({
            navBar: "idle"
        });
    }

    hide(){
        setTimeout(function(){
            this.setState({
                navBar: "hidden"
            });
        }.bind(this), 300);
    }

    goToEvents(){
        this.props.history.push({
            pathname: '/eventList/',
            state: {
                animation: "slideInRight"
            }
        });
    }

    goToHome(){
        this.props.history.push({
            pathname: '/home/',
            state: {
                animation: "slideInRight"
            }
        });
    }

    goToMap(){
        this.props.history.push({
            pathname: '/map/',
            state: {
                animation: "slideInRight"
            }
        });
    }

    goToPostcard(){
        this.props.history.push({
            pathname: '/postcard/',
            state: {
                animation: "slideInRight"
            }
        });
    }

    render(){
        let animation = "";
        if(this.state.navBar === "show") {
            animation = "animated slideInUp";
        }
        if(this.state.navBar === "hide") {
            animation = "animated slideOutDown";
        }
        if(this.state.navBar === "idle") {
            animation = "animated slideInUp delay-transition";
        }
        if(this.state.navBar !== "hidden"){
            let explore, events, ar, postcard;
            if(this.props.active === "explore"){
                explore = styles.activeHome;
            }
            if(this.props.active === "events"){
                events = styles.active;
            }
            if(this.props.active === "ar"){
                ar = styles.active;
            }
            if(this.props.active === "postcard"){
                postcard = styles.active;
            }

            return (
                <div className={[animation, styles.navBarContainer].join(' ')}>
                    <div className={styles.buttonsContainer}>
                        <div className={[styles.navBarButton, explore].join(' ')} onClick={this.goToHome}>
                            <ReactSVG src={ExploreIcon} />
                            <small><FormattedMessage id="explore" /></small>
                        </div>
                        <div className={[styles.navBarButton, events].join(' ')} onClick={this.goToEvents}>
                            <ReactSVG src={EventsIcon} />
                            <small><FormattedMessage id="events" /></small>
                        </div>
                        <div className={[styles.navBarButton, ar].join(' ')} onClick={this.goToMap}>
                            <ReactSVG src={ARIcon} />
                            <small><FormattedMessage id="ar" /></small>
                        </div>
                        <div className={[styles.navBarButton, postcard].join(' ')} onClick={this.goToPostcard}>
                            <ReactSVG src={PostcardIcon} />
                            <small><FormattedMessage id="postCards" /></small>
                        </div>
                    </div>
                </div>
            );
        } else {
            return(<div></div>);
        }
    }

}

export default NavigationBar;